import { Injectable } from "@angular/core";
import { ServiceProvider } from "./service.provider";
import { DMSBaseService } from "./dms.base.service";
import { isArray } from "lodash";
import { AssetsSearch, ItemPagination } from "app/modules/admin/apps/file-manager/file-manager.types";
@Injectable({
    providedIn: "root",
})

export class StatsService extends DMSBaseService {
    constructor(public provider: ServiceProvider) {
        super("/asset-stats", provider);
    }

   getFileCount(folderId:string){
    return this.getList(`/file-type-count/${folderId}`)
   }

   getRecentModifiedFiles(folderId:string){
    return this.getList(`/recent-modifications/${folderId}`)
   }
}